define([
    'text!./templates/mfp-proof-of-insurance.html',
], (templateStr) => {

    const directive = function () {
        return {
            restrict: 'AE',
            scope: {
                proofOfInsuranceQuestionsView: '=',
                licensePlateNumber: '=',
                licensePlateState: '=',
                contactName: '=',
                mainVehicleName: '=',
                additionalVehicleName: '=?',
            },
            template: templateStr,
            controller: ['$scope', function ($scope) {
                $scope.translateData = {
                    licensePlateNr: $scope.licensePlateNumber,
                    licensePlateState: $scope.licensePlateState,
                    vehicleOwner: $scope.contactName,
                    mainVehicleName: $scope.mainVehicleName,
                    additionalVehicleName: $scope.additionalVehicleName,
                };
            }],
            link: function (scope) {

                scope.$watch('proofOfInsuranceQuestionsView.licensePlateCurrentlyRegistered.value', () => {

                    if (!scope.proofOfInsuranceQuestionsView.licensePlateCurrentlyRegistered.value) {
                        scope.proofOfInsuranceQuestionsView.mainVehicleRegisteredToLicensePlate.value = undefined;
                        scope.proofOfInsuranceQuestionsView.licensePlateRegisteredToHolder.value = undefined;

                        if (scope.proofOfInsuranceQuestionsView.isMultivehicle.value) {
                            scope.proofOfInsuranceQuestionsView.additionalVehicleRegisteredToLicensePlate.value = undefined;
                        }
                    }
                });

                scope.$watch('proofOfInsuranceQuestionsView.mainVehicleRegisteredToLicensePlate.value', () => {

                    if (!scope.proofOfInsuranceQuestionsView.mainVehicleRegisteredToLicensePlate.value && !scope.proofOfInsuranceQuestionsView.isMultivehicle.value) {
                        scope.proofOfInsuranceQuestionsView.licensePlateRegisteredToHolder.value = undefined;
                    }
                });

                scope.$watch('proofOfInsuranceQuestionsView.licensePlateRegisteredToHolder.value', () => {

                    if (!scope.proofOfInsuranceQuestionsView.licensePlateRegisteredToHolder.value && scope.proofOfInsuranceQuestionsView.isMultivehicle.value) {
                        scope.proofOfInsuranceQuestionsView.mainVehicleRegisteredToLicensePlate.value = undefined;
                        scope.proofOfInsuranceQuestionsView.additionalVehicleRegisteredToLicensePlate.value = undefined;
                    }
                });

                //licensePlateNumber can change
                scope.$watch('licensePlateNumber', () => {
                    scope.translateData = {
                        licensePlateNr: scope.licensePlateNumber,
                        licensePlateState: scope.licensePlateState,
                        vehicleOwner: scope.contactName,
                        mainVehicleName: scope.mainVehicleName,
                        additionalVehicleName: scope.additionalVehicleName,
                    };
                });
            },
        };
    };
    directive.$inject = [];
    return directive;
});



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/mfp/directives/MFPProofOfInsurance.js